<template>
    <div class="content-slider-settings">

        <!-- settings group: PARENT BLOCK -->
        <div class="settings-group-title">
            <h6>carousel navigation</h6>
        </div>

        <!-- use dots -->
        <div class="setting">
            <!-- label background type -->
            <label>Use navigation dots:</label>
            <!-- background type child -->
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.dots" @change="reloadFlickity()">
                    Dots
                </b-form-checkbox>
            </div>
        </div>
        
        <!--  dot accent color -->
        <div class="setting" v-if="settingsFromWeebly.settings.dots">
            <Mycolorpicker elementRef="dotAccentColor" theColorPicker="allpickers" colorPickerName="Accent color dots:" />
        </div>

        <!-- use arrows -->
        <div class="setting">
            <!-- label background type -->
            <label>Use navigation arrows:</label>

            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.arrows" @change="reloadFlickity()">
                    Arrows
                </b-form-checkbox>
            </div>
        </div>

        <!-- arrow size -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <b-form-group>

                <label for="flexchild-arrowsize-input">Arrow size: <span v-b-tooltip.hover.top title="Increase/decrease the size of the arrow"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="px">
                    <b-form-input id="flexchild-arrowsize-input" type="number" v-model="settingsFromWeebly.settings.arrowSize" min="5" max="70" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- arrow radius -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <b-form-group>

                <label for="flexchild-arrowradius-input">Arrow radius: <span v-b-tooltip.hover.top title="Roundness of the arrow"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="px">
                    <b-form-input id="flexchild-arrowradius-input" type="number" v-model="settingsFromWeebly.settings.arrowRadius" min="0" max="100" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!--  arrow background color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowBg" theColorPicker="allpickers" colorPickerName="Arrow background color:" />
        </div>

        <!--  arrow background color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowBgHover" theColorPicker="allpickers" colorPickerName="Arrow background color hover:" />
        </div>

        <!--  arrow color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowColor" theColorPicker="allpickers" colorPickerName="Arrow color:" />
        </div>

        <!--  arrow color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowColorHover" theColorPicker="allpickers" colorPickerName="Arrow color hover:" />
        </div>

        <!-- slider FUNCTIONALITY -->
        <div class="settings-group-title">
            <h6>functionality</h6>
        </div>

        <!-- infinite loop -->
        <div class="setting">
            <b-form-group>

                <label>Infinite loop:</label>
                <b-form-select v-model="settingsFromWeebly.settings.loop" size="sm" @change="reloadFlickity()">
                    <option value="true">Infinite loop</option>
                    <option value="false">Stop at end</option>
                </b-form-select>

            </b-form-group>
        </div>

        <!-- autoplay -->
        <div class="setting">
            <!-- label background type -->
            <label>Use Autplay:</label>
            <!-- background type child -->
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.autoplay" @change="reloadFlickity()">
                    Autoplay
                </b-form-checkbox>
            </div>
        </div>

        <!-- autoplay speed -->
        <div class="setting" v-if="settingsFromWeebly.settings.autoplay">
            <b-form-group>

                <label for="flexchild-autoplayspeed-input">Autoplay speed: <span v-b-tooltip.hover.top title="time a slide should remain visible, value is set in ms"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="ms">
                    <b-form-input id="flexchild-autoplayspeed-input" type="number" v-model="settingsFromWeebly.settings.autoplaySpeed" min="1000" max="10000" step="500" @change="reloadFlickity()" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- visible items on desktop -->
        <div class="setting">
            <b-form-group>

                <label for="flexchild-desktopitems-input">Items desktop: <span v-b-tooltip.hover.top title="Visible amount of items for desktop view"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm">
                    <b-form-input id="flexchild-desktopitems-input" type="number" v-model="settingsFromWeebly.settings.desktopItems" min="1" max="10" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- visible items on tablet -->
        <div class="setting">
            <b-form-group>

                <label for="flexchild-tabletitems-input">Items tablet: <span v-b-tooltip.hover.top title="Visible amount of items for tablet view"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm">
                    <b-form-input id="flexchild-tabletitems-input" type="number" v-model="settingsFromWeebly.settings.tabletItems" min="1" max="10" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- visible items on mobile -->
        <div class="setting">
            <b-form-group>

                <label for="flexchild-mobileitems-input">Items phone: <span v-b-tooltip.hover.top title="Visible amount of items for phone view"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm">
                    <b-form-input id="flexchild-mobileitems-input" type="number" v-model="settingsFromWeebly.settings.phoneItems" min="1" max="10" step="1" />
                </b-input-group>

            </b-form-group>
        </div>

        <!-- slider FUNCTIONALITY -->
        <div class="settings-group-title">
            <h6>dimensions</h6>
        </div>

        <!--  items spacing -->
        <div class="setting">
            <b-form-group>

                <label for="flexchild-spacing-input">Items space between: <span v-b-tooltip.hover.top title="Spacing between items"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm">
                    <b-form-input id="flexchild-spacing-input" type="number" v-model="settingsFromWeebly.settings.itemSpacing" min="1" max="50" step="1" @change="reloadFlickity()" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!--  min-height -->
        <div class="setting">
            <b-form-group>

                <label for="flexchild-minheight-input">Minimum height: <span v-b-tooltip.hover.top title="Minimum height of the content areas"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm">
                    <b-form-input id="flexchild-minheight-input" type="number" v-model="settingsFromWeebly.settings.minHeight" min="10" max="1000" step="10" @change="reloadFlickity()" />
                </b-input-group>

            </b-form-group>
        </div> 

        

    </div>
</template>

<script>
import Mycolorpicker from './Mycolorpicker'
export default {

    name: 'ContentSliderCarouselSettings',

    data() {
        return {

        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        }

    },

    mounted() {

        // this.flickityStart()
        
    },

    components: {
        Mycolorpicker
    },

    methods: {
        
        flickityStart: function() {
            
            setTimeout(()=> {
                // settings
                var wrapAround = this.$store.state.weeblySettings.settings.loop == 'true' || this.$store.state.weeblySettings.settings.loop == true ? true : false
                var autoplay = this.$store.state.weeblySettings.settings.autoplay
                var autoplayspeed = parseInt(this.$store.state.weeblySettings.settings.autoplaySpeed)
                var useDots = this.$store.state.weeblySettings.settings.dots == 'true' || this.$store.state.weeblySettings.settings.dots == true ? true : false
                console.log('use dots: ',useDots)

                var flkty = new Flickity( '.bundle-slider', {
                    wrapAround: wrapAround,
                    autoPlay: autoplay ? autoplayspeed : false,
                    pageDots: useDots,
                    groupCells: true
                });
            },500)
            
        },

        reloadFlickity() {

            console.log('after setting applied we need to reload flickity again');
            // create it to destroy it
            var flkty = new Flickity( '.bundle-slider');
            // destroy it
            flkty.destroy();

            this.flickityStart()

        }

    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';
.errordisplay {
    border: 1px solid @warning_red;
    font-size: 12px;
    padding: 7px;
    font-weight: 700;
    border-radius: .25rem;
    margin: 7px auto;

    h2 {
        font-size: 14px;
    }

    span {
        font-style: italic;
        display: block;
        margin-top: 7px;
        color: @warning_red;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/ContentSliderCarouselSettings.vue